import Vue from 'vue';
import App from './App.vue';
import './style.scss';
import setupI18n, { setLocale, translate } from './i18n';

export function getLocale() {
  let zone = 'ru';

  const zone2locale = {
    ru: 'ru',
    by: 'ru',
    am: 'ru',
    com: 'en',
    ae: 'en',
    kz: 'kk',
    uz: 'uz',
    az: 'az'
  };

  try {
    zone = window.location.host.split('.').reverse()[0];
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
  }

  return zone2locale[zone] || 'ru';
}

new Vue({
  i18n: setupI18n(),
  created () {
    setLocale(getLocale());

    document.title = `BORK ${translate('header.mobileAppClean')}`;
    document.querySelector('meta[name="description"]').setAttribute('content', translate('seo.description'));
  },
  render: h => h(App)
}).$mount('#app');
